import { Button, Typography } from "antd";
import styled from "styled-components";

export const StyledRelevanceWrapper = styled.div`
  background-color: #ffffff;
  width: 100%;
  height: 100vh;
`;

export const StyledContainer = styled.div`
  padding: 24px;
  width: 1152px;
  height: 416px;
`;

export const StyledTitle = styled(Typography.Title)`
  padding-left: 1px;
  font-size: 24px;
`;

export const StyledCardWrapper = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  gap: 16px;
`;

export const StyledCardButton = styled(Button)`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 4px 20px;
  gap: 4px;

  width: 177px;
  height: 32px;
`;
